import { useEffect } from "react";
import { useLightbox } from "./LightboxContext";

const Lightbox = () => {
  const { src, alt, large, shown, close } = useLightbox();

  useEffect(() => {
    if (!src) return undefined;
    const onKey = (e) => {
      if (e.key === "Escape") close();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [src, close]);

  if (!src) return null;

  return (
    <div
      className="board-lightbox"
      style={{ opacity: shown ? 1 : 0 }}
      onClick={close}
    >
      <img
        src={src}
        alt={alt}
        className={`board-lightbox-img${large ? " board-lightbox-img--large" : ""}`}
        style={{ transform: shown ? "scale(1) translateY(0)" : "scale(0.92) translateY(16px)" }}
      />
      <button type="button" className="board-lightbox-close" aria-label="Close" onClick={close}>
        &times;
      </button>
    </div>
  );
};

export default Lightbox;
